import React from 'react';
import { useNavigate } from 'react-router-dom';

const PageHeader = ({
  title,
  icon = 'bi-file-text',
  onClose,
  showCloseButton = true,
  closeRoute = '/home',
  closeState = null,
  onLogout,
  backButton = true,
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      if (closeState) {
        navigate(closeRoute, { state: closeState });
      } else {
        navigate(closeRoute);
      }
    }
  };

  return (
    <div
      className="card-header small"
      style={{
        padding: '0.2rem 0.75rem',
        borderTopLeftRadius: '0.5rem',
        borderTopRightRadius: '0.5rem',
        borderBottom: '1px solid rgba(255,255,255,0.2)',
        background: 'linear-gradient(90deg, #0b3383, #0e48ad)',
        color: '#fff',
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <h6 className="mb-0" style={{ fontSize: '0.75rem', lineHeight: 1 }}>
          <i className={`bi ${icon} me-2`}></i>
          {title}
        </h6>
        <div className="d-flex align-items-center gap-2">
          {onLogout && title === 'Entidades Vinculadas ao Usuário' && (
            <button
              className="btn btn-link btn-sm text-dark p-0 mb-0"
              onClick={onLogout}
              title="Sair do sistema"
              style={{ fontSize: '0.9rem' }}
            >
              <i className="bi bi-power" />
            </button>
          )}
          {showCloseButton && title !== 'Entidades Vinculadas ao Usuário' && (
            backButton ? (
              <button
                className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
                onClick={handleClose}
                title="Voltar"
                style={{ fontSize: '0.75rem', padding: '0.15rem 0.5rem', lineHeight: 1 }}
              >
                <i className="bi bi-arrow-left me-1"></i>
                Voltar
              </button>
            ) : (
              <button
                className="btn btn-link text-white p-0 mb-0"
                onClick={handleClose}
                title="Fechar"
                style={{ fontSize: '0.9rem', textDecoration: 'none' }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
